const dialog = document.getElementById('GoogleExternalConfirm');

if (dialog instanceof HTMLDialogElement) {
  const message = dialog.querySelector('#GoogleExternalConfirmMessage');
  const continueLink = dialog.querySelector('[data-google-confirm-continue]');
  let returnFocus = null;

  const closeDialog = () => {
    if (dialog.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('a[data-google-confirm]');
    if (!trigger) return;

    event.preventDefault();
    const type = trigger.dataset.googleConfirm === 'review' ? 'review' : 'route';
    const messageText = type === 'review'
      ? dialog.dataset.reviewMessage
      : dialog.dataset.routeMessage;
    const continueText = type === 'review'
      ? dialog.dataset.reviewContinue
      : dialog.dataset.routeContinue;

    returnFocus = trigger;
    message.textContent = messageText || '';
    continueLink.textContent = continueText || '';
    continueLink.href = trigger.href;
    dialog.showModal();
  });

  dialog.querySelectorAll('[data-google-confirm-close]').forEach((button) => {
    button.addEventListener('click', closeDialog);
  });

  continueLink.addEventListener('click', () => {
    window.setTimeout(closeDialog, 0);
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  dialog.addEventListener('close', () => {
    if (returnFocus?.isConnected) returnFocus.focus();
    returnFocus = null;
  });
}
